import React from 'react'
import PropTypes from 'prop-types'

import * as S from './style'

const Checkbox = React.forwardRef(
  ({ checked, text, id, handleChange }, ref) => (
    <S.Container>
      <S.Input
        ref={ref}
        id={id}
        type="checkbox"
        checked={checked}
        onChange={handleChange}
      />
      <S.Label for={id}>{text}</S.Label>
    </S.Container>
  )
)

Checkbox.propTypes = {
  checked: PropTypes.bool.isRequired,
  text: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
}

export default Checkbox
